module.exports = __webpack_public_path__ + "static/media/PotentialAvailabilityofSugarCaneBagasse.265b86a7.gif";